import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Form, Select, Upload } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { postImportExcel } from '../../services/postservice'
import ModalCustom from '../common/Modal/ModalCustom'
import openNotification from '../common/Notification/openNotification '
import SelectField from '../common/Select/SelectField'
import styles from './styles.module.scss'
import { removeVietnameseTones } from '../../config-func'
import { dataImportExcel } from '../../services/data-customer-service'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const FormAddExcel = ({
  isModalOpen,
  setIsModalOpen,
  fetchData,
  listProject,
  setLoading
}) => {
  const [form] = Form.useForm()
  const [excelfileList, setExcelfileList] = useState([])
  const [productImport, setProdudctImport] = useState('')

  const handleImport = async () => {
    setLoading(true)
    const values = await form.validateFields()
    const formData = new FormData()
    // formData.append('from', 2)
    formData.append('excel', values.files?.file)
    values.project_id ? formData.append('project_id', values.project_id) : ''
    try {
      const res = await dataImportExcel(formData)
      setIsModalOpen(false)
      fetchData()
      form.resetFields()
      setExcelfileList([])
      openNotification('success', 'Bạn đã import thành công')
      setLoading(false)
    } catch (err) {
      setLoading(false)

      const errMes = err.response?.data?.msg
      openNotification('error', errMes || 'Có lỗi xảy ra, vui lòng thử lại')
    }
  }
  const handleChangeFileExcel = ({ fileList }) => {
    setExcelfileList(fileList)
  }

  const handlePreview = (file) => {
    // Tạo URL tạm thời để download file
    const url = URL.createObjectURL(file.originFileObj)
    const a = document.createElement('a')
    a.href = url
    a.download = file.name || 'download.xlsx' // Tên file khi tải về
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url) // Giải phóng bộ nhớ
  }

  const selectRef = useRef()

  const closeDropdown = () => {
    if (selectRef.current) {
      selectRef.current.blur() // This closes the dropdown
    }
  }

  const handleProjectSelect = (project) => {
    form.setFieldsValue({
      project_id: project.value
    })
    // setShowProjectSuggestions(false);
    // onChangeProject(project.value);
  }

  return (
    <ModalCustom
      title="Import file"
      visible={isModalOpen}
      centered
      width={600}
      // className="modal-bond"
      onCancel={() => {
        setIsModalOpen(false)
        form.resetFields()
        setProdudctImport([])
        setExcelfileList([])

        //   setFileList([])
      }}
      onConfirm={async () => {
        try {
          await form.validateFields() // Kiểm tra validation trước khi tiếp tục
          handleImport() // Nếu hợp lệ thì tiếp tục xử lý
        } catch (error) {
          
        }
      }}
      confirmText={'Lưu'}
      cancelText="Đóng"
    >
      {/* <Modal
        title={'Import file'}
        visible={createModalImportVisible}
        okText={'Lưu'}
        cancelText={'Huỷ bỏ'}
        width={600}
        onCancel={() => {
          handleModalImportVisible(false);
          formImport.resetFields();
          setProdudctImport('');
        }}
        onOk={formImport.submit} */}

      <Form
        layout="horizontal"
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 18 }}
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        labelAlign="left"
        onFinish={(value) => handleImport(value)}
        requiredMark={customizeRequiredMark}
        // onValuesChange={(value, allValues) =>
        //   
        // }
      >
        <Form.Item
          label="Upload file"
          name="files"
          style={{ padding: '0px 10px' }}
        >
          <Upload
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            fileList={excelfileList}
            onChange={handleChangeFileExcel}
            beforeUpload={() => false}
            onPreview={handlePreview}
            itemRender={(originNode, file) => (
              <a style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                {originNode}
              </a>
            )}
          >
            {excelfileList?.length <= 0 && (
              <Button icon={<UploadOutlined />}>Upload</Button>
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          label="Tên dự án"
          name="project_id"
          style={{ padding: '0px 10px' }}
        >
          <Select
            ref={selectRef}
            style={{ width: '100%' }}
            placeholder="Chọn tên dự án"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase()
              const optionValue = removeVietnameseTones(
                option?.children || ''
              ).toLowerCase()
              return optionValue.includes(inputValue)
            }}
            notFoundContent={
              <div style={{ padding: '0px' }}>
                {listProject?.find(
                  (project) => project.label.toLowerCase() === 'dự án khác'
                ) && (
                  <div
                    className={styles.otherProjectOption}
                    onClick={() => {
                      const otherProject = listProject.find(
                        (project) =>
                          project.label.toLowerCase() === 'dự án khác'
                      )
                      if (otherProject) {
                        handleProjectSelect(otherProject)
                        closeDropdown() // Close the dropdown after selection
                      }
                    }}
                  >
                    Dự án khác
                  </div>
                )}
              </div>
            }
          >
            {listProject?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <div>
          <Form.Item
            label="Template mẫu"
            name="files"
            style={{ padding: '0px 10px' }}
          >
            <a href="/template/data_khach_hang_template.xlsx">
              <DownloadOutlined /> data_khach_hang_template.xlsx
            </a>
          </Form.Item>
        </div>

        {/* <span style={{ fontWeight: 600, color: '#f54545', fontSize: 13 }}>
          *Note: Vui lòng chọn loại BĐS để tải template theo đúng loại BĐS
        </span> */}
      </Form>
    </ModalCustom>
  )
}

export default FormAddExcel
